import React, { FC, ReactElement } from 'react'
import styled from 'styled-components'
export interface Props {
    /** The linear color palette for the gradient */
    colorPalette: string[]
    /** The lowest value of the scale */
    minVal: number
    /** The highest value of the scale */
    maxVal: number
    /** The current value to point to on the scale */
    currentValue?: number
    /** The label for the current value */
    currentValueLabel?: string
}
const clamp = (num:number, min:number, max:number) => Math.min(Math.max(num, min), max);
const ColorLegend: FC<Props> = ({
  colorPalette,
  minVal,
  maxVal,
  currentValue,
  currentValueLabel
}): ReactElement => {
  const numOfTicks = 3

  const ticks = []
  const tickLabels = []
  for (let i = 0; i < numOfTicks; i++) {
    ticks.push(<div className='tick' key={i} />)
  }
  for (let i = 0; i < numOfTicks; i++) {
    tickLabels.push(
      <div className='tick-label' key={i}>
        {String(((maxVal - minVal) / (numOfTicks - 1)) * i + minVal).replace(".",",") + (currentValueLabel || "%")}
      </div>
    )
  }

  return (
    <ColorLegendWrapper>
      <div id='tick-labels'>{tickLabels}</div>
      <div id='ticks'>{ticks}</div>
      <div
        id='color-legend-bar'
        style={{
          backgroundImage:
            'linear-gradient(to right, ' +
            colorPalette.map((color) => color) +
            ')',
        }}
      />

      <svg
        id='current-value'
        style={{
          marginLeft:
          clamp((currentValue !== undefined
              ? ((currentValue - minVal) / (maxVal - minVal)) * 100
              : 50), 0, 100) + '%',
          opacity: currentValue !== undefined ? '1' : '0',
        }}
        width='88'
        height='75'
        viewBox='0 0 88 75'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M44 0L87.3013 75H0.69873L44 0Z' />
      </svg>
    </ColorLegendWrapper>
  )
}

const ColorLegendWrapper = styled.div`
 font-family: var(--font-plex);
 max-width: 670px;
 margin: 0 auto;
    font-size: 0.75em;
    @media only screen and (max-width: 600px) {
      margin-bottom: 1em;
      font-size: 0.5em;
    }
    #color-legend-bar {
      height: 0.5em;
    }
    #ticks {
      display: flex;
      justify-content: space-between;
  
      .tick {
        // flex-grow: 1;
        height: 0.75em;
        border-left: 1px solid #888888;
      }
    }
  }
  #tick-labels {
    text-align: center;
    display: flex;
    justify-content: space-between;
    .tick-label {
      flex-grow: 1;
    }
  }
  .tick-label:first-child {
    text-align: left;
  }
  .tick-label:last-child {
    text-align: right;
  }
  #current-value {
    transform: translateX(-50%);
    height: 1em;
    transition: all 500ms cubic-bezier(0.77, 0, 0.175, 1);
    path {
      fill: var(--text-color);
    }
`
export default ColorLegend
